module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Angle-double-right-2e8f71fc715248ff0a5c11b8ea34ce74.svg";